















































































































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: ['detail'],
})
export default class LinkPageNavi extends Vue {}
